<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        head: {
			title: { inner: 'Stay connected with your Tennis Social Circle', separator: '|', complement: 'Str8 Sets' },
            meta: [
				{ name: 'description', content: 'Keep in touch with your tennis friends and make new ones along the way! Tennis is a great individual game but that doesn\'t mean it has to be hard to stay in touch. The Str8 Sets Circle is the place to stay connected, view results, performance, arrange a hit, communicate and more.', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/tennis_circle' },
                { property: 'og:title', content: 'Stay connected with your Tennis Social Circle | Str8 Sets' },
                { property: 'og:description', content: 'Keep in touch with your tennis friends and make new ones along the way! Tennis is a great individual game but that doesn\'t mean it has to be hard to stay in touch. The Str8 Sets Circle is the place to stay connected, view results, performance, arrange a hit, communicate and more.' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_blue_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/tennis_circle' },
				{ name: 'twitter:title', content: 'Stay connected with your Tennis Social Circle | Str8 Sets' },
                { name: 'twitter:description', content: 'Keep in touch with your tennis friends and make new ones along the way! Tennis is a great individual game but that doesn\'t mean it has to be hard to stay in touch. The Str8 Sets Circle is the place to stay connected, view results, performance, arrange a hit, communicate and more.' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_blue_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/tennis_circle', id: 'canonical' }
			]
        }
    })
</script>

<template>
    <div>
    
        <div class="parallax image-tennis-ball-green height-350">
            <div class="container">
                <div class="feature-page-header">
                    <h1>Circle</h1>
                    <h2>Stay in touch, stay social</h2>
                </div>
                <div class="row">
                    <router-link class="clear_button" to="/faq#circle" role="button">FREQUENT QUESTIONS</router-link>
                </div>
            </div>
        </div> 

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>Tennis is a great individual game but <strong>we still make friends and pals along the way</strong>. 
                            We'd love you to keep in touch with your tennis friends on Str8 Sets and that's why we created the Circle. 
                            It's a simple way of keeping record of your tennis friends, contacting them, asking them for a hit, or simply to 
                            check out their matches and profiles.</p>
                            <p>The Circle is <strong>a great way for coaches to keep a record of their students</strong>, communicate with them and see their match results.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 heading">
                        <img class="icon" src="@/assets/images/player.svg" alt="Green Player Icon" data-no-retina>
                        <h2>How the Circle works</h2>
                        <h4>The social side of tennis!</h4>
                    </div>                            
                </div>
                <div class="row">                               
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>You can search for people and add them to your Circle within the Str8 Sets app. However, people you have previously played against or those 
                            listed in the same league competition as you will be added automatically 
                            to your Circle. You can also mark your coach via the Circle, which allows you to be automatically added to their Students list.</p>
                            
                            <p>From the Circle screen on the Str8 Sets app you can message your friends, ask them for a Matcha hit directly (which will only be seen by them), 
                            view their match results or see their player profile. If you have played against that person you can also 
                            anonymously rate their tennis skills as others can do for you!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row text-center">
                    <img class="img_inrow" :src="'/img/iphone_circle_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Circle)" v-rjs="2">
                    <img class="img_inrow" :src="'/img/iphone_circlemessage_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Circle Message)" v-rjs="2">
                </div> 
            </div>
        </section>

        <div class="parallax parallax image-tennis-ball-green height-150"></div>

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>Please note, some of these actions require a premium subscription, which you can acquire via an 
                            in-app purchase or if you're a member of a premium Str8 Sets club. If your club isn't already a 
                            Str8 Sets club let them know and enjoy the many additional benefits that come with Str8 Sets Club 
                            Management.</p>
                        </div>
                    </div>
                </div>
                <div class="spacer-large"></div>
            </div>
        </section>

    </div>
</template>